import {types} from './report.actions';

const initialState = {
    auditoria: { 
        values: {
            countCteRecebidos: 0,
            countCteDivergentes: 0,
        }, 
        filters: {
            carrier: {
                documentNumber: null,
                name: "TODOS",
            },
            period: {
                description:"Últimos 7 dias",
                period: "LAST_SEVEN_DAYS"
            },
        },
        lookup:{
            showCarrier: false,
            showPeriod: false,
            columnsCarrier:[
                {
                    field: "razaoSocial",
                    header: "Razão social",
                    columnKey: "razaoSocial",
                    sortable: false,
                    filter: true
                   
                  }
            ],
            columnsPeriod:[
                {
                    field: "description",
                    header: "Período",
                    columnKey: "description",
                    sortable: false,
                    filter: true
                   
                  }
            ]
        }
    }
}

export function reducerAuditoriaIndicator(state = initialState, action){
    let result = state;
    switch(action.type){
        case types.SET_VALUE:
            return setValue(state, action);
        case types.SET_NAME:
            return setName(state, action);
        case types.SET_CNPJ:
            return setCNPJ(state, action);
        case types.SET_PERIOD:
            return setPeriod(state, action);
        case types.SET_SHOW_CARRIER:
            return setShowCarrier(state, action);
        case types.SET_SHOW_PERIOD:
            return setShowPeriod(state, action);   
        case types.LOADER_SHOW:
            return loaderShow(state, action);
        case types.LOADER_HIDDEN:
            return loaderHide(state, action);                   
        default:
        return result; 
    }
}

function setValue(state, action){
    const auditoria = {...state.auditoria, values:action.value}
    return Object.assign({}, state, {auditoria});
}

function setName(state, action){
    return Object.assign({}, state, { value: action.name }); 
}

function setCNPJ(state, action){
    const filters = {...state.auditoria.filters,carrier:action.carrier}
    const auditoria = {...state.auditoria, filters}
    return Object.assign({}, state, {auditoria}); 
}

function setPeriod(state, action){
    const filters = {...state.auditoria.filters, period:action.period}
    const auditoria = {...state.auditoria, filters}
    return Object.assign({}, state, {auditoria});  
}

function setShowCarrier(state, action){
    const lookup = {...state.auditoria.lookup, showCarrier:action.showCarrier}
    const auditoria = {...state.auditoria, lookup}
    return Object.assign({}, state, {auditoria}); 
}

function setShowPeriod(state, action){
    const lookup = {...state.auditoria.lookup, showPeriod:action.showPeriod}
    const auditoria = {...state.auditoria, lookup}
    return Object.assign({}, state, {auditoria}); 
}

function loaderShow(state, action){
    return Object.assign({}, state, { value: action.show }); 
}

function loaderHide(state, action){
    return Object.assign({}, state, { value: action.show }); 
}

